import type { Option } from "@/Components/UI/TcSelect.vue";
import { viewMonthAgenda, viewWeek, viewDay } from "@schedule-x/calendar";

export const WEEK_HOUR_HEIGHT = 50;

export const EVENT_DATE_FORMAT = "yyyy-MM-dd HH:mm";
export const SELECTED_DATE_FORMAT = "yyyy-MM-dd";

export const CALENDAR_VIEW = {
  DAY: viewDay.name,
  WEEK: viewWeek.name,
  MONTH: viewMonthAgenda.name,
  LIST: "LIST",
} as const;

export type CalendarView = (typeof CALENDAR_VIEW)[keyof typeof CALENDAR_VIEW];

export const CALENDAR_VIEW_OPTIONS = [
  { icon: "Calendar", label: "day", value: CALENDAR_VIEW.DAY },
  { icon: "Week", label: "week", value: CALENDAR_VIEW.WEEK },
  { icon: "Calendar", label: "month", value: CALENDAR_VIEW.MONTH },
] as Option[];
